import React, { useState, useEffect } from 'react';
import './Dashboard.scss';
import LocationMap from './DataguardLocationMap';
import { useSelector } from "react-redux";
import DataguardHeatmap from './DataguardHeatmap';
import DataguardRoles from './DataguardRoles';
import DataguardBehaviorModel from './DataguardBehaviorModel';
import { useDispatch } from 'react-redux';
import DataguardIncognito from './DataguardIncognito';
import Popup from "reactjs-popup";
import LocationCard from './components/LocationCard';
import BehaviorModelsCard from './components/BehaviorModelsCard';
import PublicDataCard from './components/PublicDataCard';
import RolesCard from './components/RolesCard';
import { useHistory } from "react-router-dom";
import { DashboardMainHeader } from '../DataGuardCommonComponents';
import UserDataCard from './components/UserDataCard';

// Staggered load-in — each panel gets a slightly later animationDelay based
// on its reading-order position (top-left to bottom-right), so the whole
// dashboard cascades into view instead of popping in all at once. The actual
// fade/slide keyframes live on the shared `.column-card` rule in
// Dashboard.scss, so this is just wiring the delay per card.
const CARD_STAGGER_MS = 90;
const cardEnterStyle = (index) => ({
  animationDelay: `${index * CARD_STAGGER_MS}ms`,
});

const Dashboard = () => {
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedGraph, setSelectedGraph] = useState(null);
  let history = useHistory();

  const showExpandedView = (graph) => {
    setSelectedGraph(graph);
    setIsExpanded(true);
  }

  
  // Navigation helper functions for dashboard cards
  const navigateToDetails = (pageType) => {
    history.push(`/tenant/dataguard/details/${pageType}`);
  };

  // Individual navigation functions for each card type
  const navigateToLocations = () => navigateToDetails('locations');
  const navigateToRoles = () => navigateToDetails('roles');
  const navigateToPublicData = () => navigateToDetails('publicdata');
  const navigateToUsers = () => navigateToDetails('users');
  const navigateToBehaviorModels = () => navigateToDetails('behaviormodels');
  

  const renderPopupGraph = () => {
    if (selectedGraph === "locations") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <LocationCard isPopup={true} showExpandedView={() => null} />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "roles") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <RolesCard showExpandedView={() => null} isPopup={true} />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "heatMap") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <UserDataCard isPopup={true} showExpandedView={() => null} />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "policy") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <BehaviorModelsCard
                isPopup={true}
                showExpandedView={() => null}
              />
            </div>
          </div>
        </div>
      );
    } else if (selectedGraph === "publicData") {
      return (
        <div className="dataguard-dashboard-container">
          <div className="dataguard-dashboard-content">
            <div className="dashboard-row bottom-row">
              <PublicDataCard isPopup={true} showExpandedView={() => null} />
            </div>
          </div>
        </div>
      );
    }
    return null;
  }

  return (
    <div className="dataguard-dashboard-container">
      <div className="dataguard-dashboard-content">
        <div className={isExpanded ? "sys-guard-backdrop" : ""}>
          <Popup
            open={isExpanded}
            onClose={() => setIsExpanded(false)}
            modal
            contentStyle={{
              transition:
                "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
              transform: isExpanded ? "scale(1)" : "scale(0.9)",
              opacity: isExpanded ? "1" : "0",
              width: "auto",
            }}
          >
            <div
              className={`sys-guard-dashboard-popup-container data-guard-dashboard-popup-container ${selectedGraph}`}
            >
              {renderPopupGraph()}
              <button
                className="sys-guard-popup-close-button"
                onClick={() => setIsExpanded(false)}
              >
                &times;
              </button>
            </div>
          </Popup>
        </div>
        <DashboardMainHeader title="DataGuard Dashboard" loc="dashboard" />
        <div className="dashboard-body">
          <div className="dashboard-row bottom-row">
            <LocationCard
              showExpandedView={showExpandedView}
              onClick={navigateToLocations}
              style={cardEnterStyle(0)}
            />
            <BehaviorModelsCard
              showExpandedView={showExpandedView}
              onClick={navigateToBehaviorModels}
              style={cardEnterStyle(1)}
            />
          </div>

          <div className="dashboard-row bottom-row">
            <PublicDataCard
              showExpandedView={showExpandedView}
              onClick={navigateToPublicData}
              style={cardEnterStyle(2)}
            />
            <UserDataCard
              showExpandedView={showExpandedView}
              onClick={navigateToUsers}
              style={cardEnterStyle(3)}
            />
            <RolesCard
              showExpandedView={showExpandedView}
              onClick={navigateToRoles}
              style={cardEnterStyle(4)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;